var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.alerts")
            }
          }
        },
        [_vm._v("Volver a Alertas")]
      ),
      _vm._v(" "),
      _c(
        "block",
        { attrs: { "bordered-header": true } },
        [
          _c("template", { slot: "header" }, [
            _vm._v(_vm._s(_vm.alertTitle(_vm.studentAlert)))
          ]),
          _vm._v(" "),
          _c("template", { slot: "subheader" }, [
            _vm._v(_vm._s(_vm._f("humanizeDate")(_vm.studentAlert.createdAt)))
          ]),
          _vm._v(" "),
          _c("template", { slot: "actions" }, [
            _vm.isAlertActive && _vm.canFinishAlert
              ? _c(
                  "button",
                  {
                    staticClass: "button is-danger",
                    on: { click: _vm.finishAlert }
                  },
                  [_vm._v("\n        Finalizar Alerta\n      ")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.viewer && _vm.viewer.institutionCode === "cuc.co"
            ? _c("div", [
                _vm.studentAlert.alertType
                  ? _c("div", [
                      _vm.studentAlert.alertType.id == "44"
                        ? _c(
                            "div",
                            { staticStyle: { "font-transform": "italic" } },
                            [
                              _c("div", { staticClass: "meta-item" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "meta-name has-text-weight-bold"
                                  },
                                  [_vm._v("Beca/Crédito:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "meta-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.studentAlert.student.data
                                        .becaDescripcion || ""
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "meta-item" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "meta-name has-text-weight-bold"
                                  },
                                  [_vm._v("Valor beca/crédito:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "meta-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.studentAlert.student.data.becaValor ||
                                        ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.studentAlert.student.data.becaValor === 0
                                  ? _c("span", [_vm._v("0")])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "meta-item" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "meta-name has-text-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      "Procentaje de cobertura de la beca/crédito:"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "meta-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.studentAlert.student.data
                                        .becaCobertura || ""
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "35"
                        ? _c(
                            "div",
                            { staticStyle: { "font-transform": "italic" } },
                            [
                              _c("div", { staticClass: "meta-item" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "meta-name has-text-weight-bold"
                                  },
                                  [_vm._v("Porcentaje de créditos aprobados:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "meta-value" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.humanizePercentage(
                                          _vm.studentAlert.student.data
                                            .porcentajeCreditosAprobados
                                        ) || ""
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "43"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [_vm._v("Inclusión:")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.studentAlert.student.data.inclusion ||
                                      ""
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "36"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [_vm._v("Cantidad de semestres:")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.studentAlert.student.data
                                      .numSemestres || ""
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "42"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [_vm._v("Número de reintegros:")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.studentAlert.student.data
                                      .numReintegros || ""
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "49"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [_vm._v("Períodos ausentes:")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.studentAlert.student.data
                                      .periodosAusentes || ""
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "50"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _vm.moreThanOneSubject(
                                _vm.studentAlert.student.data
                                  .materiasSegundaVezInfo
                              )
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "meta-name has-text-weight-bold"
                                    },
                                    [_vm._v("Materias inscritas nuevamente:")]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "meta-name has-text-weight-bold"
                                    },
                                    [_vm._v("Materia inscrita nuevamente:")]
                                  ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.studentAlert.student.data
                                        .materiasSegundaVezInfo || ""
                                    ) +
                                    "\n            "
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "51"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [_vm._v("Transferencia interna:")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.studentAlert.student.data
                                        .transferenciaInternaInfo || ""
                                    ) +
                                    "\n            "
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "52"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [_vm._v("Única asignatura matriculada:")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.studentAlert.student.data
                                      .materiaUnicaInfo || ""
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "57"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [_vm._v("Retiró asignatura semestre anterior:")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.studentAlert.student.data
                                      .asignaturaRetiradaInfo || ""
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.studentAlert.alertType.id == "58"
                        ? _c("div", [
                            _c("div", { staticClass: "meta-item here-baby" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "meta-name has-text-weight-bold"
                                },
                                [
                                  _vm._v(
                                    "Asignatura perdida semestre anterior:"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "meta-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.studentAlert.student.data
                                      .asignaturaPerdidaInfo || ""
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.alertReasonWasExposed(
                        _vm.studentAlert.alertType,
                        _vm.studentAlert.alertType.id
                      )
                        ? _c("hr", { staticClass: "separator" })
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "meta-list" }, [
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Fecha:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatStandardDate")(_vm.studentAlert.createdAt)
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Registrado por:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(
                  _vm._s(
                    _vm.studentAlert.creator
                      ? _vm.studentAlert.creator.name
                      : ""
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Responsable:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.studentAlert.responsible
                        ? _vm.studentAlert.responsible.name
                        : ""
                    ) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "meta-item" }, [
              _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
                _vm._v("Factor de Riesgo:")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "meta-value" }, [
                _vm._v(_vm._s(_vm.alertRiskFactors))
              ])
            ]),
            _vm._v(" "),
            _vm.studentAlert.finishedBy
              ? _c("div", { staticClass: "meta-item" }, [
                  _c(
                    "span",
                    { staticClass: "meta-name has-text-weight-bold" },
                    [_vm._v("Finalizada por:")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.studentAlert.finishedBy.name))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.studentAlert.finishedAt
              ? _c("div", { staticClass: "meta-item" }, [
                  _c(
                    "span",
                    { staticClass: "meta-name has-text-weight-bold" },
                    [_vm._v("Fecha de finalización:")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatStandardDate")(
                          _vm.studentAlert.finishedAt
                        )
                      )
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.studentAlert.comment))
          ]),
          _vm._v(" "),
          _vm.studentAlert.finishComment
            ? _c(
                "div",
                {
                  staticClass: "description",
                  staticStyle: {
                    "margin-top": "20px",
                    "padding-top": "20px",
                    "border-top": "1px solid #e0e0e0"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "margin-bottom": "10px"
                      }
                    },
                    [_vm._v("Comentario de finalización:")]
                  ),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.studentAlert.finishComment))])
                ]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }